// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7f563963","36":"6078f142","131":"24ab1cc6","232":"93079d33","320":"04d5a93a","353":"3b40e4ea","406":"987a2aa8","453":"aca09e85","648":"5cd5d759","696":"18ad98c2","734":"a450b347","744":"4664babc","752":"326f475b","762":"f5ea9d93","785":"5e0e71f8","808":"daf38e69"}[chunkId] + ".chunk.js";
};